'use client'

import { type BottomNavigation } from 'cms-types'
import { useParams, usePathname, useRouter } from 'next/navigation'
import { Footer } from 'ui'

import { NextParams } from '@/common/types'
import { getWebsiteUrl } from '@/helpers/getWebsiteUrl'

import { pageToUrl, resolveRelation } from '../helpers'

type BottomNavigationProps = Omit<BottomNavigation, 'blocks'> & {
  children?: React.ReactNode
}

export default function BottomNavigation(props: BottomNavigationProps) {
  const pathname = usePathname()
  const locale = useParams<NextParams>().locale
  const router = useRouter()

  const onChangeLanguage = (language: string) => {
    // Read from window instead of useSearchParams, which would skip server rendering the footer
    router.push(`${getWebsiteUrl(language).origin}${pathname}${window.location.search}`)
  }

  return (
    <footer>
      <Footer
        columns={
          props.columns?.map(({ title, pages, id }) => ({
            columnTitle: title,
            pages:
              pages?.map(({ title, page, id }) => ({
                title,
                url: pageToUrl(page) ?? '',
                id,
              })) ?? [],
            id,
          })) ?? []
        }
        socials={
          props.socials?.map(item => ({
            ...item,
            icon: resolveRelation(item.icon),
          })) ?? []
        }
        logo={resolveRelation(props.logo.image)}
        logoUrl={pageToUrl(props.logo?.page) ?? ''}
        footerLegalInformation={
          props.footerLegalInformation?.map(({ title, page, id }) => ({
            title,
            url: pageToUrl(page) ?? '',
            id,
          })) ?? []
        }
        languageTypography={{
          switchTitle: props.languageSwitch.switchTitle,
          modalTitle: props.languageSwitch.modalTitle,
          modalButtonText: props.languageSwitch.modalConfirmText,
        }}
        locale={locale}
        onChangeLanguage={onChangeLanguage}
      >
        {props.children}
      </Footer>
    </footer>
  )
}
